import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Loader from '../../../../Components/Utility/Loader/Loader';
import CustomColumnTableList from './CustomColumnTableList';
import * as action from '../store/CustomSections.action';

function RangePlanColumnsCustomSection() {
  const [state, setState] = useState({
    loader: false,
    searchText: '',
  });
  const { t } = useTranslation('common');

  const reduxData = useSelector((prevState) => prevState);
  const {
    customSectionData: { customColumnList },
  } = reduxData;
  const childRef = useRef();

  const { sectionId } = useParams();
  const { searchText } = state;
  const dispatch = useDispatch();

  const handleSearch = async (e) => {
    const targetValue = e.target.value;
    setState((preState) => ({
      ...preState,
      searchText: targetValue,
    }));
  };

  useEffect(() => {
    setState((preState) => ({ ...preState, loader: true }));
    if (sectionId) {
      const res = dispatch(action.fetchCustomColumnList(sectionId));
      if (res) {
        setState((preState) => ({ ...preState, loader: false }));
      }
    }
  }, [dispatch, sectionId]);

  useEffect(() => {
    dispatch(action.fetchAllSections());
  }, [dispatch]);

  const onSave = async () => {
    const childData = await childRef.current.getColumnSectionState();
    if (childData) {
      const obj = {
        sectionId,
        sectionName: childData?.sectionName,
        type: 'critical-path',
      };
      const columns = childData?.listData;
      const res = await dispatch(action.saveColumnChanges(obj, columns, t));
      if (res.code === 500) {
        await childRef.current.resetSectionName(customColumnList?.name);
      }
    }
  };
  const expandSearchRefBin = useRef(null);
  const handleIconBinClick = () => {
    // Add a class to the input on icon click
    expandSearchRefBin.current.classList.toggle('active-input');
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title w-xs-200px">
            {t('RANGE_PLANS.CUSTOM_SECTION.ADD_COLUMNS.CUSTOM_INDEX.PAGE_TITLE')} {customColumnList?.name}
          </h4>
        </div>
        <div className="search-filter">
          {/* <SearchBar onSearch={handleSearch} placeholder={t("RANGE_PLANS.CUSTOM_SECTION.ADD_COLUMNS.CUSTOM_INDEX.SEARCH_PLACEHOLDER")} /> */}
          <div ref={expandSearchRefBin} className="common-expand-search">
            <button type="button" onClick={handleIconBinClick} className="btn btn-toggle">
              <span className="sr-only">Search</span>
              <span className="icon-Magnifying-Glass-Solid" />
            </button>

            <input
              onChange={(e) => handleSearch(e)}
              name="search"
              className="form-control"
              type="text"
              style={{ height: '33px' }}
              value={searchText}
              placeholder={t('DEVLOPMENT_ORDER.TESTING.PRODUCT_TESTING.SEARCH')}
            />
          </div>
          <div className="action-icons-container">
            <Link className="btn" to="/rangeplan/product-list/section">
              <i className="icon-close f-20" />
            </Link>
          </div>
          <div className="floting-actions">
            <button aria-label="save" className="btn" onClick={onSave} type="button">
              <i className="icon-Save f-26" />
            </button>
          </div>
        </div>
      </div>
      <div className="container-fluid py-4">{state.loading ? <Loader /> : <CustomColumnTableList searchText={searchText} ref={childRef} />}</div>
    </>
  );
}

export default RangePlanColumnsCustomSection;
